var toString = {}.toString;
var getType = function (value) {
    return toString
        .call(value)
        .replace(/^\[object /, '')
        .replace(/]$/, '');
};
export default getType;
//# sourceMappingURL=get-type.js.map